import { useState } from 'react'
import { BankPaymentCodeCard } from './components/BankPaymentCodeCard'
import { BankPaymentCodeSkeleton } from './components/BankPaymentCodeSkeleton'
import { useBankPaymentCode } from './hooks/useBankPaymentCode'

export const BankPaymentCodePage = () => {
  const {
    banks,
    isLoading,
    isError,
    refetch,
    togglingBankId,
    savingBankId,
    savingAccountId,
    toggle,
    saveBankHabitatCode,
    saveAccountCodes,
  } = useBankPaymentCode()
  const [selectedBankId, setSelectedBankId] = useState<number>()

  if (isLoading) return <BankPaymentCodeSkeleton />

  if (isError)
    return (
      <div className='card p-10 d-flex flex-row justify-content-between align-items-center gap-5'>
        <span className='text-gray-700 fs-6'>No se pudo cargar la lista de bancos.</span>
        <button type='button' className='btn btn-custom-action' onClick={() => refetch()}>
          Reintentar
        </button>
      </div>
    )

  const selectedBank = banks.find((bank) => bank.id === selectedBankId) ?? banks[0]

  return (
    <div className='d-flex flex-column gap-8'>
      <div className='card p-5 d-flex flex-row flex-wrap justify-content-between align-items-end gap-5'>
        <div className='d-flex flex-column'>
          <h2 className='text-gray-800 fs-2 fw-bold mt-2 mb-1'>Código de pago por banco</h2>
          <span className='text-muted fs-6'>
            Con el código de pago habilitado, las suscripciones de ese banco generan un código
            Habitat.
          </span>
        </div>
        {selectedBank && (
          <div className='w-250px'>
            <label htmlFor='bank-payment-code-bank' className='text-muted fs-6 mb-2'>
              Banco
            </label>
            <select
              id='bank-payment-code-bank'
              className='form-select form-select-solid'
              value={selectedBank.id}
              onChange={(e) => setSelectedBankId(Number(e.target.value))}
            >
              {banks.map((bank) => (
                <option key={bank.id} value={bank.id}>
                  {bank.description}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>

      {selectedBank ? (
        <BankPaymentCodeCard
          key={selectedBank.id}
          bank={selectedBank}
          isToggling={togglingBankId === selectedBank.id}
          isSavingBankCode={savingBankId === selectedBank.id}
          savingAccountId={savingAccountId}
          onToggle={toggle}
          onSaveBankHabitatCode={saveBankHabitatCode}
          onSaveAccountCodes={saveAccountCodes}
        />
      ) : (
        <div className='card p-10 text-gray-700 fs-6'>
          No hay bancos con cuentas recaudadoras activas.
        </div>
      )}
    </div>
  )
}
